const Corner = ({ className }) => (
  <span aria-hidden="true" className={`absolute font-mono text-sm text-line select-none ${className}`}>
    +
  </span>
);

const ImageSlot = ({ label, sub = "Image upload pending", aspect = "aspect-[4/3]", image = null, alt = "", className = "" }) => {
  if (image) {
    return (
      <div className={`relative overflow-hidden border border-line bg-fog ${aspect} ${className}`}>
        <img src={image} alt={alt || label} className="h-full w-full object-cover" loading="lazy" />
      </div>
    );
  }
  return (
    <div
      className={`relative flex ${aspect} items-center justify-center overflow-hidden border border-line bg-fog ${className}`}
    >
      <Corner className="left-3 top-2" />
      <Corner className="right-3 top-2" />
      <Corner className="bottom-2 left-3" />
      <Corner className="bottom-2 right-3" />
      <div className="px-6 text-center">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke">
          [ Campaign Visual ]
        </p>
        <p className="mt-3 font-display text-xl font-semibold tracking-tight text-ink md:text-2xl">
          {label}
        </p>
        <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-smoke/70">
          {sub}
        </p>
      </div>
    </div>
  );
};

export default ImageSlot;
